<template>
  <div class="image-list-preview">
    <template v-for="item in showImageList">
      <span :style="{width, height, padding, border}" class="image-list-preview-thumb__block"
            @click="previewImage(item)">
        <img v-if="imageType === 'base64'" class="image-list-preview-thumb__image"
             :src="'data:image/jpeg;base64,'+item"/>
        <img v-else-if="imageTypeRegExp.test(item.FILE_NAME)" class="image-list-preview-thumb__image"
             :src="$Dolphin.path.filePath+item.FILE_NAME"/>
        <template v-else>
          <dol-icon class="image-list-preview-thumb__file-icon" type="file"/>
          <dol-icon class="image-list-preview-thumb__file-icon image-list-preview-thumb__download" type="download"/>
          <div class="image-list-preview-thumb__file-name" :title="item.ORGI_FILE_NAME || item.FILE_NAME">{{ item.ORGI_FILE_NAME || item.FILE_NAME }}</div>
        </template>

        <div v-if="removeIcon" class="image-list-preview-thumb__remove-icon" @click.stop="removeFile(item)">
          <a-icon type="delete" />
        </div>
      </span>
    </template>
    <a-modal :visible="previewVisible" centered :footer="null" width="800px" @cancel="handleCancel">
      <img class="image-list-preview-thumb__preview" v-if="previewImageUrl" :src="previewImageUrl"/>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: "dol-image-list-preview",
  props: {
    imageList: {type: Array, default: () => []},
    imageType: {type: String, default: 'file'}, //file | base64
    width: {type: String, default: '100px'},
    height: {type: String, default: '100px'},
    padding: {type: String, default: '5px'},
    border: {type: String, default: '1px solid #bbbbbb'},
    removeIcon: {type: Boolean, default: false},
  },
  data() {
    return {
      previewVisible: false,
      previewImageUrl: '',
      imageTypeRegExp: /\.(png|jpg|jpeg|bmp|gif|webp|psd|svg|tiff)$/i
    };
  },
  computed: {
    showImageList() {
      // let imageList = [];
      // this.imageList.forEach(item =>{
      //   imageList.push(this.$Dolphin.path.filePath+item.FILE_NAME)
      // })
      // return imageList;
      return this.imageList.filter(image => !!image);
    }
  },
  methods: {
    handleCancel() {
      this.previewVisible = false;
      this.previewImageUrl = '';
    },
    previewImage(item) {
      if (this.imageType === 'base64') {
        this.previewImageUrl = 'data:image/jpeg;base64,' + item;
        this.previewVisible = true;
      } else if (this.imageTypeRegExp.test(item.FILE_NAME)) {
        this.previewImageUrl = this.$Dolphin.path.filePath + item.FILE_NAME;
        this.previewVisible = true;
      } else {
        window.open(this.$Dolphin.path.filePath + item.FILE_NAME);
      }
    },
    removeFile(item){
      this.$confirm({
        content: this.$t('confirmDeletion'),
        onOk: () => {
          this.$h5Api({
            type: '2010',
            data: [{"GUID_CODE":item.GUID_CODE}],
          }).then(({data}) => {
            this.$emit('removeFile', item);
          });
        },
        onCancel() {
        },
      });
    }
  },
  created() {

  }
};
</script>

<style lang="scss" scoped>
.image-list-preview {
  display: flex;
  flex-wrap: wrap;

  .image-list-preview-thumb__block {
    border: 1px solid #bbbbbb;
    padding: 5px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    align-content: center;
    justify-items: center;
    justify-content: center;
    width: 100px;
    height: 100px;
    text-align: center;
    flex-direction: column;
    position: relative;
    margin: 5px;

    //+ .image-list-preview-thumb__block {
    //  margin-left: 10px;
    //}

    .image-list-preview-thumb__image {
      max-width: 100%;
      max-height: 100%;
      cursor: pointer;
    }

    .image-list-preview-thumb__file-icon {
      font-size: 30px;
    }

    .image-list-preview-thumb__file-icon.image-list-preview-thumb__download {
      display: none;
    }

    &:hover {
      .image-list-preview-thumb__file-icon {
        display: none;
      }

      .image-list-preview-thumb__file-icon.image-list-preview-thumb__download {
        cursor: pointer;
        display: block;
      }
    }

    .image-list-preview-thumb__file-name {
      font-size: 12px;
      overflow: hidden;
      width: 100%;
      text-align: center;
      white-space: nowrap;
    }

    .image-list-preview-thumb__remove-icon{
      position: absolute;
      top: -8px;
      right: -8px;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #cccccc;
      color: #666666;
      cursor: pointer;

    }
  }
}

.image-list-preview-thumb__preview {
  width: 100%;
}
</style>
